// extracted by mini-css-extract-plugin
export default {"modal_index":"PollAdminOptions_modal_index__GdQ6E","container":"PollAdminOptions_container__y+s51","admin_button":"PollAdminOptions_admin_button__4CQpV"};